/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Src_3_NameInputs */

const en_wb_management_src_3_name = /** @type {(inputs: Wb_Management_Src_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team priorities`)
};

const lv_wb_management_src_3_name = /** @type {(inputs: Wb_Management_Src_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komandas prioritātes`)
};

/**
* | output |
* | --- |
* | "Team priorities" |
*
* @param {Wb_Management_Src_3_NameInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_src_3_name = /** @type {((inputs?: Wb_Management_Src_3_NameInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Src_3_NameInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_src_3_name(inputs)
	return en_wb_management_src_3_name(inputs)
});